// extracted by mini-css-extract-plugin
export var colorSquare = "_l6-0";
export var danger = "_l6-5";
export var lightPink = "_l6-8";
export var neutralBlue = "_l6-7";
export var neutralYellow = "_l6-6";
export var normal = "_l6-1";
export var primary = "_l6-2";
export var primaryLight = "_l6-3";
export var solidBlack = "_l6-g";
export var solidGreen = "_l6-b";
export var solidLightBlue = "_l6-d";
export var solidNavy = "_l6-c";
export var solidOrange = "_l6-f";
export var solidPink = "_l6-e";
export var solidRed = "_l6-9";
export var solidYellow = "_l6-a";
export var success = "_l6-4";